import { render, staticRenderFns } from "./MailApproval.vue?vue&type=template&id=19b1a87b"
import script from "./MailApproval.ts?vue&type=script&lang=ts&external"
export * from "./MailApproval.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports